webpackJsonp([75],{

/***/ 1264:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1265);


/***/ }),

/***/ 1265:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(174);

var _datetime2 = _interopRequireDefault(_datetime);

var _fr = __webpack_require__(776);

var _fr2 = _interopRequireDefault(_fr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('fr', _fr2.default);

/***/ })

},[1264]);


// WEBPACK FOOTER //
// app/datetime.fr-87002b9771e937fd2578.js